import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { getArticleBySlug } from '@/mocks/articleContent';

export default function OOPBuySpreadsheetCompleteGuide() {
  const article = getArticleBySlug('/guide/oopbuy-spreadsheet-complete-guide');
  if (!article) return null;
  return (
    <main>
      <Navbar />
      <ArticleLayout
        title={article.title}
        subtitle={article.subtitle}
        readTime={article.readTime}
        image={article.image}
        imageAlt={article.imageAlt}
      >
        {article.content()}
      </ArticleLayout>
      <Footer />
    </main>
  );
}